import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-faqs-page',
  templateUrl: './faqs-page.component.html',
  styleUrl: './faqs-page.component.scss'
})
export class FaqsPageComponent {
  private readonly siteUrl = environment.SITE_URL;

  public faqs: any = [
    {
      title: '¿Qué tipo de proyectos construyen?',
      info: 'Desarrollamos proyectos para salud, industria y comercio, sector público, vivienda y desarrollos; desde obra civil y acabados hasta soluciones integrales llave en mano.',
    },
    {
      title: '¿Cómo garantizan la calidad y la seguridad?',
      info: 'Aplicamos estándares y normativas nacionales (NOM) e internacionales, con supervisión en sitio, control de calidad, gestión de riesgos y protocolos de seguridad en todas las etapas.',
    },
    {
      title: '¿Cuál es el proceso para iniciar un proyecto?',
      info: 'Levantamos requerimientos, definimos alcance, tiempos y presupuesto, elaboramos ingeniería y cronograma, y firmamos contrato con objetivos claros y entregables acordados.',
    },
    {
      title: '¿Trabajan en todo México?',
      info: 'Sí. Contamos con cobertura nacional y equipos locales y foráneos para atender proyectos en múltiples estados.',
    },
    {
      title: '¿Cómo se manejan cambios de alcance?',
      info: 'Usamos órdenes de cambio con impacto medido en tiempo y costo, siempre informando y aprobando con el cliente antes de ejecutarlos.',
    },
    {
      title: '¿Qué certificaciones o estándares siguen?',
      info: 'Trabajamos con buenas prácticas de dirección de proyectos, normativas aplicables al sector (salud, industria, público) y especificaciones técnicas del cliente.',
    },
    {
      title: '¿Cómo solicito una cotización?',
      info: 'Puedes usar el botón “Solicitar Cotización”, escribirnos por el formulario de contacto o llamarnos. Te pediremos datos básicos del proyecto para elaborar una propuesta.',
    },
  ]

  constructor(
    private titleService: Title, private metaService: Meta,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.setMetaTags();
  }

  setMetaTags() {
    const metaTitle = 'Preguntas Frecuentes de Construcción | Paredes y Asociados';
    const metaDescription = 'Resuelve tus dudas sobre proyectos de construcción: procesos, calidad, seguridad, cobertura y cómo solicitar una cotización con Paredes y Asociados en México.';
    const url = `${this.siteUrl}/faq/`;
    const image = this.toAbsoluteUrl('/assets/images/faqs-page.webp');

    this.titleService.setTitle(metaTitle);
    this.metaService.updateTag({ name: 'description', content: metaDescription });

    this.metaService.updateTag({ name: "robots", content: "index, follow" });
    this.metaService.updateTag({ name: "description", content: metaDescription });
    this.setCanonicalUrl(url);

    this.metaService.updateTag({ name: "keywords", content: "Paredes y Asociados, Construcción México, Proyectos, Calidad y Seguridad" });

    this.metaService.updateTag({ property: "og:type", content: "website" });
    this.metaService.updateTag({ property: "og:locale", content: "es_MX" });
    this.metaService.updateTag({ property: "og:site_name", content: "Paredes y Asociados" });

    this.metaService.updateTag({ property: "og:title", content: metaTitle });
    this.metaService.updateTag({ property: "og:description", content: metaDescription });
    this.metaService.updateTag({ property: "og:url", content: url });
    this.metaService.updateTag({ property: 'og:image', content: image });
    this.metaService.updateTag({ property: 'og:image:alt', content: 'Paredes y Asociados' });

    this.metaService.updateTag({ name: "twitter:card", content: "summary_large_image" });
    this.metaService.updateTag({ name: "twitter:title", content: metaTitle });
    this.metaService.updateTag({ name: "twitter:description", content: metaDescription });
    this.metaService.updateTag({ name: "twitter:url", content: url });
    this.metaService.updateTag({ name: "twitter:image", content: image });
  }

  private setCanonicalUrl(url: string): void {
    const head = this.document.head;
    let link = this.document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  private toAbsoluteUrl(path: string): string {
    if (!path) {
      return `${this.siteUrl}/assets/images/logos/logo-full.webp`;
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    return `${this.siteUrl}${path}`;
  }

}
